export enum QualityTagType {
  positive = 'positive',
  negative = 'negative',
}

export interface QualityTagCardProps {
  qualityTag: QualityTagType;
}
